import { render, staticRenderFns } from "./MenuImportaciones.vue?vue&type=template&id=288afcc6"
import script from "./MenuImportaciones.vue?vue&type=script&lang=js"
export * from "./MenuImportaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports